import Modal from '@mui/material/Modal';
import { ReactNode } from 'react';
import cx from 'classnames';
import styles from '../sass/components/Modal.module.scss';

interface ModalProps {
  children?: ReactNode;
  open: boolean;
  onClose: () => void;
  disableBackdropClick?: boolean;
  contentClassName?: string;
}

function WrappedModal({
  children,
  open,
  onClose,
  disableBackdropClick = false,
  contentClassName,
}: ModalProps) {
  const handleClose = (reason: string) => {
    if (disableBackdropClick) {
      if (reason !== 'backdropClick') {
        onClose();
      }
    } else {
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={(_event, reason) => handleClose(reason)}
    >
      <div className={cx(styles.modal, contentClassName)}>
        {children}
      </div>
    </Modal>
  );
}

export default WrappedModal;
